import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface AddModuleToUserPlanParams {
	readonly userId: string;
	readonly moduleId: string;
}

@Injectable({ providedIn: 'root' })
export class AddModuleToUserPlanApiMutation extends ApiMutation<
	string,
	AddModuleToUserPlanParams
> {
	client = 'content';
	document = gql`
		mutation AddModuleToUserPlan($moduleId: UUID!, $userId: UUID!) {
			addModuleToUserPlan(moduleId: $moduleId, userId: $userId)
		}
	`;
	method = 'addModuleToUserPlan';
}
